import { useEmersonCatalogParams } from "@emerson/hooks/useEmersonCatalogParams/useEmersonCatalogParams";

const useEmersonCatalogClearSearch = () => {
  const [catalogParams, setCatalogParams] = useEmersonCatalogParams();
  const initFilters = {
    allergens: undefined,
    brands: undefined,
    certifications: undefined,
    conditions: undefined,
    excludedIngredients: undefined,
    forms: undefined,
    ingredients: undefined,
    isOnlyShowFavorites: undefined,
    isOnlyShowInStock: undefined,
    isOnlyShowEmersonNew: undefined,
    onlyIngredient: undefined,
    populations: undefined,
    supplementTypes: undefined,
    relevanceFilters: undefined,
    categories: undefined,
    eqpLevels: undefined,
    taxonomies: undefined,
    more: undefined,
  };

  const clearSearchFilters = () => {
    setCatalogParams({
      ...catalogParams,
      ...initFilters,
    });
  };

  const clearSearch = () => {
    setCatalogParams({
      ...catalogParams,
      ...initFilters,
      query: undefined,
      typeaheadSelectionId: undefined,
    });
  };

  return { clearSearchFilters, clearSearch };
};

export { useEmersonCatalogClearSearch };
